// Providence community — factual config (replace values here if they change).
export const CHURCH = {
  name: "Providence",
  address: "57 Rue de l'université, 93160 Noisy-le-Grand",
  phone: "07 89 65 10 90",
  email: "fredericmsv@gmail.com",
  services: {
    fr: ["Vendredi : 19h30 – 21h00", "Dimanche : 10h00 – 12h00"],
    en: ["Friday: 19h30 – 21h00", "Sunday: 10h00 – 12h00"],
  },
};

export const OFFERINGS = {
  fr: [
    "Un accueil chaleureux pour les nouveaux arrivants",
    "Des repas partagés",
    "De l'entraide pour les démarches et le logement",
    "Des petits groupes conviviaux",
    "Des célébrations et des événements pour nouveaux étudiants",
    "Un accompagnateur / parrain si vous le souhaitez",
  ],
  en: [
    "A warm welcome for newcomers",
    "Shared meals",
    "Help with paperwork and housing",
    "Friendly small groups",
    "Celebrations and events for new students",
    "A mentor / buddy if you wish",
  ],
};

export const EVENTS = [
  {
    id: "welcome-dinner",
    icon: "UtensilsCrossed",
    title: { fr: "Dîner d'accueil", en: "Welcome dinner" },
    when: { fr: "15 sept. — 19h00", en: "Sept 15 — 19h00" },
    type: { fr: "Repas partagé", en: "Shared meal" },
  },
  {
    id: "service-friday",
    icon: "Church",
    title: { fr: "Culte du vendredi", en: "Friday service" },
    when: { fr: "Chaque vendredi — 19h30", en: "Every Friday — 19h30" },
    type: { fr: "Célébration", en: "Celebration" },
  },
  {
    id: "service-sunday",
    icon: "Church",
    title: { fr: "Culte du dimanche", en: "Sunday service" },
    when: { fr: "Chaque dimanche — 10h00", en: "Every Sunday — 10h00" },
    type: { fr: "Célébration", en: "Celebration" },
  },
];
